import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { graphql, compose } from "react-apollo";
import {
  mutationUpdateTemplateList,
  mutationUpdateTemplateReply
} from "Apollo";
import { ShowNotice } from "Store";
import Icon from "module-common/Icon";
import Input from "module-common/Input";
import TextArea from "module-common/TextArea";
import DeleteButton from "./DeleteButtonWithMutation";
import { Collapse } from "antd";
const Panel = Collapse.Panel;

const customPanelStyle = {
  background: "transparent",
  borderRadius: 0,
  marginBottom: 0,
  border: 0,
  overflow: "hidden",
  borderBottom: "1px solid #ddd"
};

export default compose(
  graphql(mutationUpdateTemplateList, {
    name: "mutationUpdateList"
  }),
  graphql(mutationUpdateTemplateReply, {
    name: "mutationUpdateReply"
  })
)(
  class Row extends Component {
    static propTypes = {
      id: PropTypes.number,
      index: PropTypes.number,
      title: PropTypes.string,
      arrOfTemplate: PropTypes.array
    };
    state = {
      editingList: false,
      editingReply: false,
      newContentList: "",
      newContentReply: "",
      replyId: 0
    };

    render() {
      const { id, index, title, arrOfTemplate } = this.props;
      const {
        editingList,
        editingReply,
        newContentList,
        newContentReply
      } = this.state;

      const viewTemplate = arrOfTemplate.map((template, index) => {
        return (
          <Stream key={index}>
            {editingReply && this.state.replyId === template.id ? (
              <form onSubmit={this.onEditReplyClick}>
                <TextAreaField
                  key={index}
                  value={newContentReply}
                  onChange={e =>
                    this.setState({
                      newContentReply: e.target.value
                    })
                  }
                />
              </form>
            ) : (
              <StreamWord>
                {template.content.split("\n").map((item, key) => {
                  return (
                    <span key={key}>
                      {item}
                      <br />
                    </span>
                  );
                })}
              </StreamWord>
            )}

            <IconWrapperStream>
              <IconEdit
                name="edit"
                onClick={() =>
                  this.onEditReplyClick(template.id, template.content)
                }
              />

              <DeleteButton isDeleteList={false} id={template.id} />
            </IconWrapperStream>
          </Stream>
        );
      });

      return (
        <Wrapper>
          <Collapse bordered={false} defaultActiveKey={["1"]}>
            <IconWrapper>
              <IconEdit name="edit" onClick={this.onEditListClick} />
              <DeleteButton isDeleteList={true} id={id} />
            </IconWrapper>
            {editingList ? (
              <form onSubmit={this.onEditListClick}>
                <InputField
                  value={newContentList}
                  onChange={e =>
                    this.setState({ newContentList: e.target.value })
                  }
                />
              </form>
            ) : null}
            <Panel header={title} key={index} style={customPanelStyle}>
              {viewTemplate}
            </Panel>
          </Collapse>
        </Wrapper>
      );
    }
    onEditListClick = () => {
      const editingList = this.state.editingList;

      if (editingList) {
        // submit
        this.onUpdateList();
        this.setState({ editingList: false });
      } else {
        this.setState({ editingList: true, newContentList: this.props.title });
      }
    };

    onEditReplyClick = (replyIds, contents) => {
      const editingReply = this.state.editingReply;
      if (editingReply) {
        // submit
        this.onUpdateReply();
        this.setState({ editingReply: false });
      } else {
        this.setState({
          editingReply: true,
          replyId: replyIds,
          newContentReply: contents
        });
      }
    };

    onUpdateList = () => {
      try {
        this.props.mutationUpdateList({
          variables: {
            id: this.props.id,
            content: this.state.newContentList
          },
          refetchQueries: ["getTemplateList"]
        });
        ShowNotice("template-reply-update-success");
      } catch (error) {
        ShowNotice("template-reply-update-error");
      }
    };

    onUpdateReply = () => {
      try {
        this.props.mutationUpdateReply({
          variables: {
            id: this.state.replyId,
            content: this.state.newContentReply
          },
          refetchQueries: ["getTemplateList"]
        });
        ShowNotice("template-reply-update-success");
      } catch (error) {
        ShowNotice("template-reply-update-error");
      }
    };
  }
);

const Wrapper = styled.div``;

const Stream = styled.div`
  display: flex;
  background: #e8e8e8;
  padding: 10px 60px 10px 10px;
  border-radius: 4px;
  margin-right: 12px;
  margin-top: 8px;
  justify-content: space-between;
`;

const StreamWord = styled.span``;

const IconEdit = styled(Icon)`
  margin-left: 10px;
  margin-right: 10px;
`;

const InputField = styled(Input)`
  position: absolute;
  z-index: 2;
  margin-top: 5px;
  margin-left: 10px;
  width: 400px;
`;

const TextAreaField = styled(TextArea)`
  width: 400px;
  height: 100px;
`;

const IconWrapper = styled.div`
  position: absolute;
  right: 20px;
  margin-top: 12px;
  margin-right: 10px;
  z-index: 2;
`;

const IconWrapperStream = styled.div`
  position: absolute;
  right: 20px;
  margin-right: 40px;
  z-index: 2;
`;



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/template-reply/RowWithMutation.js